export const CREATIVE_RICH_MSG_URL_HTTPS = 'CREATIVE_RICH_MSG_URL_HTTPS';
export const CREATIVE_RICH_MSG_URL_FILETYPE = 'CREATIVE_RICH_MSG_URL_FILETYPE';



// WEBPACK FOOTER //
// ./src/constants/ValidationTypes.js